export default {
  inserted (el) {
    el.addEventListener('click', function () {
      window.history.back()
    })
  }
}



// WEBPACK FOOTER //
// ./src/directives/back-link.js